import { initSentry, SentryErrorBoundary } from './observability/sentry';
initSentry();

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import App from './App.jsx';
import './styles.css';
import { initConsoleErrorBuffer } from './lib/consoleErrorBuffer.js';
import { installGlobalErrorListeners } from './lib/errorReporter.js';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import { ThemeProvider } from './context/ThemeContext.jsx';

initConsoleErrorBuffer();
installGlobalErrorListeners();

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SentryErrorBoundary>
      <QueryClientProvider client={queryClient}>
        {(() => {
          const Router = import.meta.env.VITE_DEMO_MODE === 'true' ? HashRouter : BrowserRouter;
          return (
            <Router>
              <ThemeProvider>
                <ErrorBoundary>
                  <App />
                </ErrorBoundary>
              </ThemeProvider>
              <Toaster position="top-right" toastOptions={{
                style: { background: '#10102a', color: '#fff', border: '1px solid #252550' },
              }} />
            </Router>
          );
        })()}
      </QueryClientProvider>
    </SentryErrorBoundary>
  </React.StrictMode>
);
